import {
  FavoriteMilitaryOccupation,
  UserReclassifying
} from '@cpd-app/generated';

export const favoriteMilitaryOccupationsFeatureKey =
  'favoriteMilitaryOccupations';

export interface FavoriteMilitaryOccupationsState {
  favoriteMilitaryOccupations: FavoriteMilitaryOccupation[];
  similarMilitaryOccupations: FavoriteMilitaryOccupation[];
  militaryOccupationsForGoal: FavoriteMilitaryOccupation[];
  userReclassifying: UserReclassifying | undefined;
  /**
   * WALK-70 review. Whether the member's leaving-or-staying answer has been
   * read from the server yet. Until it has, an empty answer means "not known",
   * not "not answered", and the goal dialog must not hold Continue on it.
   */
  userReclassifyingLoaded: boolean;
}

export const initialFavoriteMilitaryOccupationsState: FavoriteMilitaryOccupationsState =
  {
    favoriteMilitaryOccupations: null,
    similarMilitaryOccupations: null,
    militaryOccupationsForGoal: null,
    userReclassifying: null,
    userReclassifyingLoaded: false
  };
